export const diffInDays = (from: Date, to: Date) => {
  const timeDiff = to.getTime() - from.getTime()
  return Math.round(timeDiff / (1000 * 3600 * 24))
}
export const diffInMinutes = (from: Date, to: Date) => {
  const diffInMilliseconds = to.getTime() - from.getTime()
  return Math.floor(diffInMilliseconds / (1000 * 60))
}
